import { parseNumero } from "../calculos";
import { F } from "../gerencialFields";
import { startOfDay } from "../status";
import { statusPulmao } from "./bufferManager";
import { ETAPA_LABELS, ORDEM_ETAPAS, getEtapaAtual } from "./etapas";

export const CAPACIDADE_DEFAULT = 4;
export const JANELA_DEFAULT_DIAS_UTEIS = 7;
const PESO_CHEGANDO = 0.7;

function indexEtapa(etapa) {
  return ORDEM_ETAPAS.indexOf(etapa);
}

function complexidadeAmbiente(amb) {
  return parseNumero(amb?.[F.COMPLEXIDADE_TOTAL]) || 1;
}

export function detectarGargalo(
  ambientes,
  {
    capacidades = {},
    hoje = new Date(),
    janelaDiasUteis = JANELA_DEFAULT_DIAS_UTEIS,
    zonasPulmao,
  } = {}
) {
  const today = startOfDay(hoje) || new Date();
  const lista = Array.isArray(ambientes) ? ambientes : [];

  const ranking = ORDEM_ETAPAS.map((etapa) => {
    const idxEtapa = indexEtapa(etapa);
    let cargaComplexidade = 0;
    let countWip = 0;
    let countChegando = 0;
    let pretosNaEtapa = 0;

    for (const amb of lista) {
      const atual = getEtapaAtual(amb);
      if (!atual) continue;
      const complexidade = complexidadeAmbiente(amb);

      if (atual === etapa) {
        cargaComplexidade += complexidade;
        countWip++;
        const { zona } = statusPulmao(amb, today, zonasPulmao);
        if (zona === "preto") pretosNaEtapa++;
        continue;
      }

      const idxAtual = indexEtapa(atual);
      if (idxEtapa - idxAtual === 1) {
        cargaComplexidade += complexidade * PESO_CHEGANDO;
        countChegando++;
      }
    }

    const capacidade = capacidades[etapa] ?? CAPACIDADE_DEFAULT;
    const capacidadeJanela = capacidade * janelaDiasUteis;
    const utilizacao =
      capacidadeJanela > 0 ? cargaComplexidade / capacidadeJanela : 0;

    return {
      etapa,
      label: ETAPA_LABELS[etapa],
      cargaComplexidade,
      countWip,
      countChegando,
      capacidade,
      capacidadeJanela,
      utilizacao,
      pretosNaEtapa,
    };
  });

  const ordenado = [...ranking].sort((left, right) => {
    if (right.utilizacao !== left.utilizacao) {
      return right.utilizacao - left.utilizacao;
    }
    return right.pretosNaEtapa - left.pretosNaEtapa;
  });

  const gargalo = ordenado[0]?.utilizacao > 0 ? ordenado[0] : null;
  return { gargalo, ranking, janelaDiasUteis };
}
